import { useCookieContext } from "contexts/cookies/CookieContext";
import React from "react";
import { useTranslation } from "react-i18next";

const BetaVersion: React.FC = () => {
  const { isAr } = useCookieContext();
  const { t, i18n } = useTranslation("Shared");

  return (
    <div
      className={`position-fixed bottom-0 ${isAr ? "start-0" : "end-0"}`}
      style={{
        width: 0,
        height: 0,
        borderLeft: isAr ? "100px solid red" : undefined,
        borderRight: !isAr ? "100px solid red" : undefined,
        borderTop: "100px solid transparent",
        zIndex: 1050,
      }}
    >
      <span
        className="position-absolute text-white text-center"
        style={{
          transform: isAr ? "rotate(-45deg)" : "rotate(45deg)", 
          bottom: "15px",
          [isAr ? "right" : "left"]: "50px", 
          fontSize: "14px",
          fontWeight: "bold",
        }}
      >
      {t("betaVersion")}
      </span>
    </div>
  );
};

export default BetaVersion;
